__turbopack_context__.v({
  "className": "silkscreen_20b2439e-module__SGaK_W__className",
});
